import { AutogenModelCodePackageTypeLookup, AutogenRowCodePackageTypeLookup } from "./autogen/AutogenModelCodePackageTypeLookup";

export class ModelCodePackageTypeLookup extends AutogenModelCodePackageTypeLookup<RowCodePackageTypeLookup> {
	constructor() {
		super(RowCodePackageTypeLookup);
	}
}

export class RowCodePackageTypeLookup extends AutogenRowCodePackageTypeLookup {
}